// src/lib/sponsored.js
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  updateDoc,
  where,
} from 'firebase/firestore'
import { db } from '../firebase'
import { fetchProduct } from './products'

// ---- LECTURE POUR LA HOME ----

export async function fetchActiveShelves(limitCount = 2) {
  const q = query(
    collection(db, 'sponsoredShelves'),
    where('isActive', '==', true),
    orderBy('position', 'asc'),
    limit(limitCount)
  )
  const snap = await getDocs(q)
  return snap.docs.map(d => ({ id: d.id, ...d.data() }))
}

async function fetchShelfProductsRaw(shelfId) {
  const col = collection(db, 'sponsoredShelves', shelfId, 'products')
  const snap = await getDocs(col)
  return snap.docs
    .map(d => ({ id: d.id, ...d.data() }))
    .filter(x => x.productId)
    .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
}

/** Retourne [{ shelf, products }] pour la Home */
export async function fetchActiveShelvesWithProducts(limitCount = 2) {
  const shelves = await fetchActiveShelves(limitCount)
  const results = []

  for (const shelf of shelves) {
    const links = await fetchShelfProductsRaw(shelf.id)
    const products = []
    for (const l of links) {
      const p = await fetchProduct(l.productId)
      if (p) products.push(p)
    }
    results.push({ shelf, products })
  }

  return results
}

// ---- CRUD SIMPLE POUR L’ADMIN ----

export async function addSponsoredShelf(data) {
  const ref = await addDoc(collection(db, 'sponsoredShelves'), {
    title: '',
    subtitle: '',
    ctaLabel: 'Shop now',
    ctaHref: '/catalog',
    bannerImageUrl: '',
    rightTitle: '',
    rightSubtitle: '',
    badgeLabel: '',
    position: 1,
    isActive: true,
    ...data,
  })
  const snap = await getDoc(ref)
  return { id: snap.id, ...snap.data() }
}

export async function updateSponsoredShelf(id, data) {
  const ref = doc(db, 'sponsoredShelves', id)
  await updateDoc(ref, data)
}

export async function deleteSponsoredShelf(id) {
  const ref = doc(db, 'sponsoredShelves', id)
  await deleteDoc(ref)
}

export async function addShelfProduct(shelfId, productId, sortOrder = 1) {
  const col = collection(db, 'sponsoredShelves', shelfId, 'products')
  await addDoc(col, { productId, sortOrder })
}

export async function removeShelfProduct(shelfId, linkId) {
  const ref = doc(db, 'sponsoredShelves', shelfId, 'products', linkId)
  await deleteDoc(ref)
}

export async function listShelfProducts(shelfId) {
  return await fetchShelfProductsRaw(shelfId)
}
